import { useCircleAIShellStore } from "@circle-react-uikit/CircleAIAppShell/store/circleAIShellStore";
import type { ReactNode } from "react";

interface ShellRailPanelProps {
  children: ReactNode;
}

export const ShellRailPanel = ({ children }: ShellRailPanelProps) => {
  const isVisible = useCircleAIShellStore(s => s.isRightSidebarVisible);
  const storedWidth = useCircleAIShellStore(s => s.rightSidebarWidth);
  const computedWidth = isVisible ? storedWidth : 0;

  return (
    <div
      style={{ width: computedWidth, minWidth: computedWidth }}
      className="shrink-0 overflow-hidden transition-[width,min-width]"
    >
      <aside
        data-testid="circle-ai-shell-rail-panel"
        aria-hidden={!isVisible || undefined}
        className="border-primary dark:border-secondary flex size-full min-h-0 flex-col overflow-hidden border-l"
      >
        {children}
      </aside>
    </div>
  );
};
